<template>
    <md-button class="md-raised">New Game</md-button>
</template>

<script>

export default {
  name: 'NewGame',
  props: {
  },
   data: () => ({
  }),
  methods: {
    NewGame() {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>